export default {
  cmsUrl: process.env.REACT_APP_CMS_URL,
  authUrl: process.env.REACT_APP_USER_URL,
  sessionUrl: process.env.REACT_APP_SESSION_APP_URL,
  subscriptionUrl: process.env.REACT_APP_SUBSCRIPTION_APP_URL,
  sessionApiKey: process.env.REACT_APP_API_KEY,
  secretKey: process.env.REACT_APP_SECRET_KEY,
  bugsnagApiKey: process.env.REACT_APP_BUGSNAG_API_KEY
}
